/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

import { StringExtensions } from '@msdyn365-commerce-modules/retail-actions';
import * as React from 'react';

/**
 * Items added to cart error message.
 */
export interface IItemsAddedErrorProps {
    errorMessage?: string;
}

/**
 * Items added error.
 * @param errorProps - The error properties.
 * @param errorProps.errorMessage - The error message to show.
 * @returns The alert element showing items added errors.
 */
export const ItemsAddedErrorComponent: React.FC<IItemsAddedErrorProps> = ({
    errorMessage
}) => {
    if (StringExtensions.isNullOrEmpty(errorMessage)) {
        return null;
    }

    return (
        <span className='msc-alert-danger msc-alert'>
            <span className='msi-exclamation-triangle' aria-hidden='true' />
            <span>
                {errorMessage}
            </span>
        </span>
    );
};
